var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-dropdown',{ref:"dropdown",attrs:{"id":"list-action-dropdown","label":_vm.$attrs.label,"position":_vm.$attrs.position,"button-class":"btn btn-primary btn-lg","menu-class":"dropdown action-dropdown-primary"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }